import Request from '../common/api/request';
import ServiceResultFactory from '../common/api/ServiceResultFactory';
import DiscoverFilterMapping from '../common/config/DiscoverFilterMapping.json';
import { v4 as uuidv4 } from 'uuid';

const discoverFilterNameMapping = {
  'Products and services': 'functions',
  Applications: 'applications',
  'Ingredient benefits': 'performance_claims',
};

const clientId = 'reed-integration';

const searchDiscoverProducts = (
  locale,
  baseApiUrl,
  query,
  filters,
  discoverEventId,
) => {
  let url = `${baseApiUrl}search`;
  let sortOptions = [];
  if (!query && !filters.length) {
    url += '?shuffle=true';
    sortOptions = [
      {
        field: uuidv4(),
        direction: 'random',
      },
    ];
  }
  const body = {
    event: discoverEventId,
    target: 'INGREDIENTS', // only fetch ingredients
    segment: 'PERSONALCARE', // only fetch personal care products
    query: query,
    size: 3, // pick top 3 products, default sorted by score
    filters: filters,
    sort: sortOptions,
  };
  return Request.publicPost(url, body, { 'client-id': clientId })
    .then((response) => ServiceResultFactory.fromSuccess(response.body))
    .catch((error) => ServiceResultFactory.fromError(locale, error));
};

const convertToDiscoverFilters = (atlasFilters) => {
  let discoverFilters = [];
  if (!atlasFilters) return discoverFilters;

  let nestedFilters = [];
  Object.keys(discoverFilterNameMapping).forEach((filterName) => {
    let lvl0Filters = [];
    let lvl1Filters = [];
    atlasFilters.forEach((filterCategory) => {
      const categoryWithLvl1Filters = filterCategory.filter((selectedFilter) =>
        selectedFilter.includes(`filters.${filterName}.lvl1`),
      );
      if (categoryWithLvl1Filters.length) {
        lvl1Filters.push(filterCategory);
      }
      const categoryWithLvl0Filters = filterCategory.filter((selectedFilter) =>
        selectedFilter.includes(`filters.${filterName}.lvl0`),
      );
      if (categoryWithLvl0Filters.length) {
        lvl0Filters.push(filterCategory);
      }
    });
    let applicableFilters = lvl1Filters.length ? lvl1Filters : lvl0Filters;
    if (!applicableFilters.length) return;
    nestedFilters.push({ filterName: filterName, And: applicableFilters[0] });
  });

  nestedFilters.forEach((filterCategory) => {
    filterCategory.And.forEach((selectedFilter) => {
      const filterValues = selectedFilter.split(':');
      const value = filterValues.at(-1);
      const filteredValue = value.split('>').at(-1).trim();

      const mappedValue = DiscoverFilterMapping[filterCategory.filterName]
        ? DiscoverFilterMapping[filterCategory.filterName].filter(
            (val) => val[filteredValue] !== undefined,
          )
        : [];
      const filterValue = mappedValue.length
        ? mappedValue.at(0)[filteredValue]
        : '';
      if (filterValue === '') return;
      filterValue.forEach((val) => {
        discoverFilters.push({
          field: discoverFilterNameMapping[filterCategory.filterName],
          value: val,
        });
      });
    });
  });
  return discoverFilters;
};

export default {
  searchDiscoverProducts,
  convertToDiscoverFilters,
};
